export default __webpack_public_path__ + "static/media/misc-books5-1920w.706f68af.png";